<template>
  <div id="app">
    <div class="content">
      <h1 class="topTitle">#BlackBoycott</h1>
      <router-view/>
    </div>
    <br/>
    <footer>
    </footer>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('getLists');
  },
};
</script>

<style lang="scss" scoped>
@import './style/colors.sass';
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $azure;
  background-color: $onyx;
}

.topTitle {
  margin: 15px;
}
</style>
